import React from 'react';
import {Route, Redirect} from 'react-router-dom';
import {useSelector} from 'react-redux';

function PrivateAuthHoc({component: Component, ...rest}) {
  const userData = useSelector((state) => state.auth.auth);
  const token = userData.token ? userData.token : '';
  return (
    <Route
      {...rest}
      render={(prop) =>
        token !== '' ? <Component {...prop} /> : <Redirect to={'/'} />
      }
    />
  );
}

export default PrivateAuthHoc;
